import { cn } from "@/lib/utils";
import { forwardRef, InputHTMLAttributes } from "react";

export const Input = forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement> & { error?: boolean }
>(function Input({ error, ...props }, ref) {
  return (
    <input
      {...props}
      className={cn(
        "w-full rounded-md border-0 bg-gray-100 px-4 py-3 text-gray-700 outline-primary read-only:outline-none disabled:opacity-50 dark:bg-gray-900 dark:text-white",
        error && "outline-red-400",
        props.className
      )}
      ref={ref}
    />
  );
});
